import React from 'react';
import { useNavigate } from 'react-router-dom';
import "../../style/AppPages.css";
import "../../style/FormStyles.css";
import { useTranslation } from 'react-i18next';

const CreationSuccessPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div class="page-padding">
            <p class="account-text">{t("update.creationSuccessLabel")}</p>
        </div>
    )
};

export default CreationSuccessPage;

